import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../public/WAW_Logo.webp'


const _hoisted_1 = { class: "col-md-7 col-xs-12" }
const _hoisted_2 = { href: "https://discord.gg/dU84EgXu2T" }
const _hoisted_3 = { style: {"padding-bottom":"15px"} }
const _hoisted_4 = { style: {"padding-bottom":"15px"} }
const _hoisted_5 = { style: {"padding-bottom":"15px"} }
const _hoisted_6 = { style: {"padding-bottom":"15px"} }
const _hoisted_7 = { style: {"padding-bottom":"15px"} }
const _hoisted_8 = { style: {"padding-bottom":"15px"} }
const _hoisted_9 = { style: {"padding-bottom":"15px"} }
const _hoisted_10 = { style: {"padding-bottom":"15px"} }
const _hoisted_11 = { style: {"padding-bottom":"15px"} }
const _hoisted_12 = { style: {"padding-bottom":"15px"} }

import 'bootstrap/dist/css/bootstrap.min.css';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container mt mb", { 'dark-mode': _unref(store).state.dark }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'about-rtl' : 'row' ]),
      style: _normalizeStyle({
        direction: (_ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar') ? 'rtl' : 'ltr',
        textAlign: (_ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar') ? 'right' : 'left',
      })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", {
          style: {"font-family":"'Bebas Neue', cursive","font-size":"50px"},
          class: _normalizeClass([ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ])
        }, _toDisplayString(_unref(t)('modal.header')), 3),
        _createElementVNode("p", {
          class: _normalizeClass(["overflow-auto", [ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ]]),
          style: {"font-size":"20px","font-family":"'Roboto', sans-serif"}
        }, [
          _createTextVNode(_toDisplayString(_unref(t)('modal.textOne')), 1),
          _createElementVNode("b", null, _toDisplayString(_unref(t)('modal.projectWorldAtWar')), 1),
          _createTextVNode(_toDisplayString(_unref(t)('modal.textTwo')), 1),
          _createElementVNode("b", null, _toDisplayString(_unref(t)('modal.projectWorldAtWar')), 1),
          _createTextVNode(_toDisplayString(_unref(t)('modal.textThree')), 1),
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('modal.textFour')), 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('modal.textFive')), 1),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('modal.textSix')), 1),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('modal.textSix2')), 1),
          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('modal.textSeven')), 1),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('modal.textEight')), 1),
          _cache[9] || (_cache[9] = _createElementVNode("b", null, "support@projectwaw.org", -1)),
          _createTextVNode(_toDisplayString(_unref(t)('modal.textNine')), 1),
          _createElementVNode("a", _hoisted_2, _toDisplayString(_unref(t)('modal.textTen')), 1),
          _createTextVNode(_toDisplayString(_unref(t)('modal.textEleven')), 1),
          _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
        ], 2),
        _createElementVNode("h2", {
          id: "names",
          style: {"font-family":"'Bebas Neue', cursive","font-size":"40px"},
          class: _normalizeClass([ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ])
        }, _toDisplayString(_unref(t)('modal.credits.credits')), 3),
        _createElementVNode("p", {
          class: _normalizeClass(["overflow-auto", [ _ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar' ? 'text-right' : 'text-left' ]]),
          style: {"font-size":"20px","font-family":"'Roboto', sans-serif","margin-bottom":"16px"}
        }, [
          _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.homage')), 1)
        ], 2),
        _createElementVNode("table", {
          style: _normalizeStyle([{
            direction: (_ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar') ? 'rtl' : 'ltr',
            textAlign: (_ctx.$store.state.locale == 'he' || _ctx.$store.state.locale == 'ar') ? 'right' : 'left',
            fontSize: '20px',
            fontFamily: 'Roboto, sans-serif'
          }, {"width":"100%","border-collapse":"collapse","line-height":"1.4"}])
        }, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameOne')), 1),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descOne')), 1)
              ]),
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameTwo')), 1),
                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descTwo')), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameThree')), 1),
                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descThree')), 1)
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameFour')), 1),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descFour')), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameFive')), 1),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descFive')), 1)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameSix')), 1),
                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descSix')), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameSeven')), 1),
                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descSeven')), 1)
              ]),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameEight')), 1),
                _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descEight')), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameNine')), 1),
                _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descNine')), 1)
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('modal.credits.nameTen')), 1),
                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("em", null, _toDisplayString(_unref(t)('modal.credits.descTen')), 1)
              ])
            ])
          ])
        ], 4)
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-5 col-xs-3" }, [
        _createElementVNode("img", {
          class: "img-responsive center-block hidden-xs",
          src: _imports_0,
          alt: ""
        })
      ], -1))
    ], 6)
  ], 2))
}
}

})